import { render } from "./AllBuyersView.vue?vue&type=template&id=2984661c"
import script from "./AllBuyersView.vue?vue&type=script&lang=js"
export * from "./AllBuyersView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__